<!-- Toolbar -->
<div class="toolbar" role="banner">
  <span class="header-font" style="margin-left: 40px; font-size: medium;">Aleman Enterprises</span>
    <div class="spacer"></div>
    
    <a class="header-font header-margin" routerLink="/user/bob" onmouseover="blue"><img style="width: 80px; height: auto; margin-top: 7px;" src="../assets/img/aleman-realty-logo-navbar.png"/></a>
    <a class="header-font header-margin" target="_blank" href="http://alemanmortgaecompany.com"><img style="width: 90px; height: auto; margin-top: 10px;" src="../assets/img/aleman-mortgage-company-logo-navbar.png"/></a>
    <a class="header-font header-margin" style="margin-right: 40px" routerLink="/user/bob"><img style="width: 75px; height: auto; margin-top: 10px;" src="../assets/img/aleman-realty-event-room-logo-navbar.png"/></a>
</div>

<div class="content" role="main">
  <div style="margin-left: 35%;">
    <div><img style="height: 100px; width: 100px; box-shadow: 10px 10px 5px grey;" alt="Aleman" title="Aleman" src="../assets/img/aleman-enterprises-logo.png"/></div>
    <div id="foraleman">is for Aleman</div>
    <div class="wrapper">



      <div class="paragraph">
        <p>Aleman Enterprises is a family built and family run endeavors. My family means everything to me and is why they
          serve as my core team. My beautiful wife Jamilla is the behind the scenes guru that keeps me on track and hence keeps the greater company
          on the right path. My son Christian and daughter Isabella bring me so much support and inspiration. I love them both dearly. Beyond them"
          we have one other real estate broker/ mortgage broker and seven licensed real estate agents that individually bring so much to the table.
          They’re great!
        </p>
        <br/>
        <p>
          They each have their own strengths and talents. Mostly, they love real estate! We are a strong team and function well together.
              We’re a team that ultimately focuses on – “getting the job done.” A concept I grind into everything I do. A concept I impress upon my
              children and my companies. When the team is in motion, you can feel the energy. It’s great to be around. With that, I welcome you to: Aleman Realty, Aleman Mortgage Company, and Aleman Event Room!
        </p>
      </div>

      <br>
      <br>
      <div>
        <p style="font-family: Corinthian; font-size: 40px;">Hector Aleman</p>
        <p class="paragraph">Hector Aleman</p>
      </div>
    </div>
  </div>
  <!-- <div style="width: 34%; height: 100%">
    <img class="resize" id="signature" alt="Hector Aleman" title="Hector Aleman" src="../assets/img/aleman-realty-logo.png"/>
    <img class="resize" id="signature" alt="Hector Aleman" title="Hector Aleman" style="margin-left: 100px;" src="../assets/img/aleman-mortgage-company-logo.png"/>
    <img class="resize" id="signature" alt="Hector Aleman" title="Hector Aleman" style="margin-left: 250px;" src="../assets/img/aleman-realty-event-room-logo.png"/>
  </div> -->
</div>

<router-outlet></router-outlet>